import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "form"]
  
  connect() {
    this.timeout = null
  }
  
  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }
  
  search() {
    // Debounce - wait 300ms after user stops typing
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    
    this.timeout = setTimeout(() => {
      this.formTarget.requestSubmit()
    }, 200)
  }
  
  // Clear search when input is emptied
  clear() {
    if (this.inputTarget.value === "") {
      this.formTarget.requestSubmit()
    }
  }
}
